/**
 * 新規登録した action に対してのみ ActionEditRule を適用する補助関数を提供する。
 * action id を正規化してから applyActionEditRules を呼び出し、通常 DB と transaction の両方から使える。
 */
import { fiatCurrencyIds } from '@pkg/basic'
import type { DatabaseWithTransaction, TransactionDatabase } from '../../types'
import {
  applyActionEditRules,
  applyActionEditRulesOnDatabase,
} from './applyActionEditRules'

type ApplyActionEditRulesToInsertedActionsParameters = {
  readonly database: DatabaseWithTransaction
  readonly actionIdList: readonly string[]
  readonly invalidateCalculationState?: boolean
}

type ApplyActionEditRulesToInsertedActionsOnDatabaseParameters = Omit<
  ApplyActionEditRulesToInsertedActionsParameters,
  'database'
> & {
  readonly database: TransactionDatabase
}

/**
 * 指定 database 上で新規登録した action id 群に対して ActionEditRule を適用する。
 * @param params database と action id 一覧を受け取る。
 * @returns 値は返さない。
 */
export const applyActionEditRulesToInsertedActionsOnDatabase = async ({
  database,
  actionIdList,
  invalidateCalculationState,
}: ApplyActionEditRulesToInsertedActionsOnDatabaseParameters): Promise<void> => {
  const normalizedActionIdList = [...new Set(actionIdList)]
  if (normalizedActionIdList.length === 0) {
    return
  }

  await applyActionEditRulesOnDatabase({
    database,
    actionIdList: normalizedActionIdList,
    fiatCurrencyIds,
    invalidateCalculationState,
  })
}

/**
 * 新規登録した action id 群に対して ActionEditRule を適用する。
 * @param params database と action id 一覧を受け取る。
 * @returns 値は返さない。
 */
export const applyActionEditRulesToInsertedActions = async ({
  database,
  actionIdList,
  invalidateCalculationState,
}: ApplyActionEditRulesToInsertedActionsParameters): Promise<void> => {
  await applyActionEditRules({
    database,
    actionIdList,
    fiatCurrencyIds,
    invalidateCalculationState,
  })
}
